import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { VersionCheckComponent } from './version-check.component';

@NgModule({
  declarations: [VersionCheckComponent],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  exports: [VersionCheckComponent],
})
export class VersionCheckModule {}
